import React, { useState, useEffect, useCallback } from "react";
import UserService from "../services/user.service";
import SubSiteService from "../services/catalog.service";
import AuthService from "../services/auth.service";
import Navbar from "react-bootstrap/Navbar";
import ProductMenu from "./ProductMenu";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { green } from "../util/themes";
import { red } from "../util/themes";
import { PersonCircle, Cart, Search, Pencil } from 'react-bootstrap-icons';
import { selectAllMenuItems, getMenu } from '../reducers/menu'
import Spinner from "react-bootstrap/Spinner";
import { cart, cartCount, showCart, toggleShowCart, removeItemFromOrder } from '../reducers/cart';
import { isLoggedIn, isAdmin, getUser, logout, getSubsite } from '../reducers/auth';
import { getAllSubsites, allSubsites } from '../reducers/subsite';
import { searchCatalog } from '../reducers/catalog';
import SwitchSiteModal from './modals/SwitchSiteModal';
import Offcanvas from 'react-bootstrap/Offcanvas';
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import Dropdown from "react-bootstrap/Dropdown";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;


const IgniteNavBar = () => {
  const { categoryId } = useParams();
  let navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const dispatch = useDispatch();
  const currentUser = useSelector(getUser);
  const currentSubsite = useSelector(getSubsite);
  const showCartFlag = useSelector(showCart);
  const { isSuperAdmin } = useSelector(state => state.auth);
  const cartCountValue = useSelector(cartCount);
  const cartItems = useSelector(cart);
  const loginStatus = useSelector(isLoggedIn);
  const adminStatus = useSelector(isAdmin);
  const [siteModalShow, setSiteModalShow] = useState(false);
  const [theme, setTheme] = useState("dark");
  const [content, setContent] = useState('');

  const closeSiteModal = () => {
    setSiteModalShow(false);
  }

  console.log("CURRENT USER NAV", currentUser);
  const subsiteStatus = useSelector(state => state.subsite.status);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    dispatch(toggleShowCart(false));
  }
  const handleShow = () => {
    dispatch(toggleShowCart(true));
  }

  useEffect(() => {
    console.log("NAV Count UPDATED", cartCountValue);
  }, [cartCountValue]);

  const logOut = useCallback(() => {
    green();
    dispatch(logout());
  }, [dispatch]);


  const removeCartItem = (item) => {
    console.log("CART ITEM", item);
    dispatch(removeItemFromOrder(item.id));
  }

  const formatPantsSize = (sizeName) => {
    var isFour = /^\d{4}$/.test(sizeName);
    if (isFour) {
      return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
    } else {
      return sizeName;
    }
  }


  let totalAmount = 0;
  let totalCountItems = 0;
  let cartContent = [];
  let totals = [0, 0];

  for (var i = 0; i < cartItems.length; i++) {
    totalAmount += (cartItems[i].price * cartItems[i].quantity);
    totalCountItems += cartItems[i].quantity;
  }

  totals = [totalAmount, totalCountItems];

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target),
      formDataObj = Object.fromEntries(formData.entries());
    console.log(formDataObj);

    navigate("../productlist?searchTerm=" + formDataObj.searchTerm, { replace: true });

    //dispatch(searchCatalog([formDataObj.searchTerm, 1, 10]));
  }

  return (
    <>
      <Navbar expand="lg" data-bs-theme={currentSubsite.subsite_content?.lightTheme ? "light" : "dark"} style={{backgroundColor: currentSubsite.subsite_content?.topNavBgColor ? currentSubsite.subsite_content?.topNavBgColor : "#000000"}}>
        <Container fluid>
          <Navbar.Toggle variant={currentSubsite.lightTheme ? "light" : "dark"} />
          <Navbar.Brand as={Link} to="/featured" >
            {process.env.REACT_APP_ENV === 'demo' &&
              <Image className="navbar-brand" src="/logo-demo.png" alt="Logo" fluid />
            }
            {process.env.REACT_APP_ENV === 'production' &&
              <Image className="navbar-brand" src="/logo.png" alt="Logo" fluid />
            }
          </Navbar.Brand>
          <Navbar.Text style={{  border: "1px solid ", padding: 10, borderRadius: 5 }} >
            You are shopping on: <br />
            {currentSubsite.subsiteName}  {currentUser && currentUser.subsites && currentUser.subsites.length > 1 && (
              <Pencil style={{ marginLeft: 10 }} onClick={(e) => setSiteModalShow(true)} />
            )}
          </Navbar.Text>
          <Navbar.Collapse className="justify-content-end" data-bs-theme={currentSubsite.subsite_content?.lightTheme ? "light" : "dark"}>
            {loginStatus ? (
              <Container fliud style={{ flexDirection: "column" }}>
                <Row style={{ alignItems: "flex-end" }}>
                  <Col xs={12} sm={12} md={5} style={{ alignSelf: "center" }}>
                    <Form noValidate onSubmit={handleSearchSubmit}>
                      <Form.Group className="nav-form" controlId="formBasicEmail">
                        <Form.Control type="text" placeholder="Search" name="searchTerm" />
                        <Button variant="secondary" type="submit">
                          <Search />
                        </Button>
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col xs={12} sm={12}  md={7} style={{ alignSelf: "center" }}>
                    <Container fluid style={{ alignItems: "flex-end" }}>
                      <Row className="justify-content-end">
                        <Col sm="auto" style={{ alignSelf: "center" }}>
                          <Dropdown style={{ paddingRight: 5, marginTop: 4 }}>
                            <Dropdown.Toggle variant={currentSubsite.subsite_content?.lightTheme ? "light" : "dark"} id="dropdown-basic">
                              <PersonCircle size={18} /> {currentUser.firstname + " " + currentUser.lastname}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item href="/profile">Profile</Dropdown.Item>
                              {adminStatus && (
                                <Dropdown.Item href="/admin/home">Admin Section</Dropdown.Item>
                              )}

                              <Dropdown.Item href="/logout">Logout</Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </Col>
                        <Col sm="auto" style={{ alignSelf: "center" }}>
                        <div onClick={handleShow} className="navbar-text" style={{marginTop: 4, marginRight: 10, padding: 10, borderRadius: 5, border: "1px solid"}}>
                  {currentSubsite && currentSubsite.paymentOptions.includes("balance") && currentUser.subsiteBalance &&
                    <><span >{(currentUser.subsiteBalance.balance - totals[0]).toLocaleString(undefined, {
                        style: "currency",
                       currency: "USD",
                      })}</span><br />
                      </>
                    }
                  <Cart />Cart <br />
                  <Badge bg="primary" style={{ width: "100%" }}>{cartCountValue ? cartCountValue : 0}</Badge>
                </div>
                        </Col>
                        <Col sm="auto" style={{ alignSelf: "center" }}>
                          {currentSubsite.logoFilename && (
                              <Image fluid style={{height:70 }} src={`${BACKEND_URL}/uploads/subsites/${currentSubsite.logoFilename}`} />
                          )}
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            ) : (
              <Nav.Link as={Link} to="/login" >Login</Nav.Link>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {(loginStatus || currentSubsite.type === "retail") && <ProductMenu currentCategory={categoryId} menuBgColor={currentSubsite.subsite_content?.menuBgColor} menuTextHoverColor={currentSubsite.subsite_content?.menuTextHoverColor} menuTextColor={currentSubsite.subsite_content?.menuTextColor}/>}
      <Offcanvas show={showCartFlag} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Shopping Cart</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div class="cart-container">
            <Button variant="warning" onClick={() => { navigate('/checkout'); dispatch(toggleShowCart(false)); }}>Checkout</Button>
            <div class="total">Total ({totals[1]} items): <strong>{totals[0].toLocaleString(undefined, {
              style: "currency",
              currency: "USD",
            })}</strong></div>

            <div class="cart-item-container">
              <div class="price-label">PRICE</div>

              {cartItems.map(item => (
                <div class="cart-item" key={"item" + item.id}>
                  <div style={{ display: "inline-block", position: "relative" }}>
                    <div style={{ display: "inline-block", position: "relative" }}>
                      <img className="bg-image" src={item.product.frontModelImage} width={150}></img>
                      {item.decorations && item.decorations.map((logo, i) => (
                        <img className="logo-image" src={apiUrl + logo.imageUrl} width={logo.width + '%'} style={{ left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}></img>
                      )
                      )}
                    </div>
                  </div>
                  <div class="content">
                    <div class="title">{item.product.style.title}</div>
                    <div class="color">Color: {item.colorName}</div>
                    <div class="size-name">Size: {formatPantsSize(item.sizeName)}</div>
                    <div class="quantity">Quantity: {item.quantity}</div>
                    <Button variant="primary" onClick={() => { removeCartItem(item) }}>Remove</Button>

                  </div>
                  <div class="price">{item && item.price && (item.price).toLocaleString(undefined, {
                    style: "currency",
                    currency: "USD",
                  })}</div>

                </div>
              ))}

              <div class="total">Total ({totals[1]} items): <strong>{totals[0].toLocaleString(undefined, {
                style: "currency",
                currency: "USD",
              })}</strong></div>
            </div>
            <Button variant="warning" onClick={() => { navigate('/checkout'); dispatch(toggleShowCart(false)); }}>Checkout</Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      {siteModalShow &&
        <SwitchSiteModal show={siteModalShow} closeModal={closeSiteModal} redirect="/featured" />
      }
    </>
  );
};
export default IgniteNavBar;



